export type MenuV2ItemChoice = IMenuV2Item | IMenuV2ItemGroup;
export type MenuV2ItemsArray = Array<MenuV2ItemChoice>;

export enum MenuV2EntityStatus {
  Disabled,
  Enabled
}

export interface IMenuV2Contract {
  menus: IMenuV2Category[];
  itemGalleries?: IMenuV2ItemGallery[];
  popularItems: IMenuV2Item[];
}

export interface IMenuV2Category {
  _id: string;
  displayName: string;
  description?: string;
  sections: IMenuV2Section[];
  status?: MenuV2EntityStatus;
  sortOrder?: number;
  itemGallery?: IMenuV2ItemGallery;
  scheduleTimes?: IMenuV2Schedule;
}

export interface IMenuV2Section {
  uid: string;
  displayName: string;
  description?: string;
  items: MenuV2ItemsArray;
  status?: MenuV2EntityStatus;
  itemGallery?: IMenuV2ItemGallery;
  defaultAppearance?: 'expanded' | 'partiallyExpanded' | 'collapsed';
  scheduleTimes?: IMenuV2Schedule;
}

interface IMenuV2BaseItem {
  // items should have either one of these ids
  _id?: string;
  itemId?: string;
  displayName: string;
  sectionItemType: 'item' | 'group';
  imageId?: string;
  imageUrl?: string;
  imageWidth?: number;
  imageHeight?: number;
  thumbnailImageId?: string;
  thumbnailImageUrl?: string;
  thumbnailImageWidth?: number;
  thumbnailImageHeight?: number;
  description?: string;
  modifierGroups?: string[];
  badge?: IMenuV2Badge;
  tags?: IMenuV2Tag[];
}

export interface IMenuV2Item extends IMenuV2BaseItem {
  sectionItemType: 'item';
  alcohol?: IMenuV2ItemAlcoholInfo;
  recommendedItems: IMenuV2Item[];
  inStock: boolean;
  price?: number;
}

export interface IMenuV2ItemGroup extends IMenuV2BaseItem {
  sectionItemType: 'group';
  items: IMenuV2Item[];
}

interface IMenuV2ItemAlcoholInfo {
  containsAlcohol: boolean;
  quantity?: {
    value: number;
  };
}

export interface IMenuV2ModifierGroup {
  _id: string;
  constraints?: {
    min?: number;
    max?: number;
  };
  name?: string;
  displayName?: string;
  options?: IMenuV2Modifier[];
  allowMultiplesOfEachOption?: boolean;
  guestInstructions?: string;
}

interface IMenuV2Modifier {
  itemId: string;
  displayName?: string;
  description?: string;
  price?: number;
  nestedGroups?: IMenuV2ModifierGroup[];
  constraints?: {
    max?: number;
  };
  inStock?: boolean;
  alcohol?: {
    containsAlcohol: boolean;
  };
  isDefault?: boolean;
}

export interface IMenuV2ItemGallery {
  sortOrder?: number;
  items: IMenuV2Item[];
  displayName?: string;
  description?: string;
}

export interface IMenuV2Badge {
  text?: string;
  textColor?: string;
  backgroundColor?: string;
}

export interface IMenuV2Tag {
  shortCode?: string;
  name?: string;
}

export interface IMenuV2Schedule {
  start?: string;
  end?: string;
}
